// Opt-in HTML legends let translated labels wrap outside the fixed-height canvas.
// Keep buttons across updates so toggling a series does not lose keyboard focus.
export default {
    id: 'nexlabLineLegend',
    defaults: { enabled: false },

    afterUpdate(chart, _args, options) {
        if (!options.enabled) return;

        const container = chart.canvas.parentElement.nextElementSibling;
        if (!container?.matches('[data-chart-line-legend]')) return;

        const items = chart.options.plugins.legend.labels.generateLabels(chart);
        const existing = new Map([...container.children].map(button => [Number(button.dataset.index), button]));

        for (const [position, item] of items.entries()) {
            const index = item.datasetIndex;
            let button = existing.get(index);

            if (!button) {
                button = document.createElement('button');
                button.type = 'button';
                button.dataset.index = index;
                button.addEventListener('click', () => {
                    chart.setDatasetVisibility(index, !chart.isDatasetVisible(index));
                    chart.update();
                });

                const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
                svg.setAttribute('viewBox', '0 0 32 12');
                svg.setAttribute('aria-hidden', 'true');
                const line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
                line.setAttribute('x1', '1');
                line.setAttribute('x2', '31');
                line.setAttribute('y1', '6');
                line.setAttribute('y2', '6');
                svg.append(line);
                button.append(svg, document.createElement('span'));
            }

            const line = button.querySelector('line');
            line.setAttribute('stroke', item.strokeStyle);
            line.setAttribute('stroke-width', item.lineWidth);
            line.setAttribute('stroke-dasharray', (item.lineDash ?? []).join(' '));
            button.querySelector('span').textContent = chart.data.datasets[index].legendLabel ?? item.text;
            button.setAttribute('aria-label', item.text);
            button.setAttribute('aria-pressed', String(!item.hidden));
            if (container.children[position] !== button) {
                container.insertBefore(button, container.children[position] ?? null);
            }
            existing.delete(index);
        }

        for (const button of existing.values()) button.remove();
    },

    beforeDestroy(chart) {
        const container = chart.canvas.parentElement?.nextElementSibling;
        if (container?.matches('[data-chart-line-legend]')) container.replaceChildren();
    },
};
